module.exports = __webpack_public_path__ + "static/media/india_pic1.09f95fc7.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/india_pic1.jpg
 ** module id = 453
 ** module chunks = 0
 **/